import { render } from "./RestaurantBooking.vue?vue&type=template&id=07bfc8da"
import script from "./RestaurantBooking.vue?vue&type=script&lang=js"
export * from "./RestaurantBooking.vue?vue&type=script&lang=js"

import "@/css/booking/booking.css?vue&type=style&index=0&lang=css&external"
import "./RestaurantBooking.vue?vue&type=style&index=1&id=07bfc8da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__